/**
 * Shared social icon component
 * Maps a FooterSocialLinkType to the matching Lucide icon.
 */

import type React from "react";
import { ExternalLink, Mail } from "lucide-react";
import { DOMAIN_SOCIAL_PLATFORM_ICON } from "@/lib/utils/social-platform-links";

import type { FooterSocialLinkType } from "../../../../_types";

interface SocialIconProps {
  type: FooterSocialLinkType;
  className?: string;
}

/**
 * Returns the appropriate Lucide icon for a footer social link type. The per-platform glyphs (all
 * but "email"/"other") come from the shared `DOMAIN_SOCIAL_PLATFORM_ICON` map, so this can't drift
 * from the email builder's identical picker.
 * @param type - The social link platform
 * @param className - Tailwind sizing/color classes (defaults to "h-5 w-5")
 */
export function SocialIcon({ type, className = "h-5 w-5" }: SocialIconProps): React.ReactElement {
  if (type === "email") return <Mail className={className} />;
  if (type === "other") return <ExternalLink className={className} />;
  const Icon = DOMAIN_SOCIAL_PLATFORM_ICON[type];
  return <Icon className={className} />;
}
